import { palette } from '../palette';

const MuiSelect = {
  styleOverrides: {
    select: {
      padding: 0,
      height: '22px',
      fontStyle: 'normal',
      backgroundColor: 'transparent',
      // '& .MuiSelect-placeholder, & em': {
      //   color: 'red', // Set placeholder color
      //   fontStyle: 'italic',           // Optional: italic for placeholder
      // },
    },
    root: {
      height: '42px',
      borderRadius: '8px',
      padding: '8.5px 14px',
      gap: '10px',
      fontSize:'1rem',
    },
    standard: ({ theme }: any) => ({
      fontSize: '1rem',
      color: theme.palette.text.primary,
      '&:hover': {
      borderBottom: 'none',
      },
    }),
    icon: {
      height: '24px',
      width: '24px',
      top: '8.93px',
      borderRadius: '0px',
      color: palette.info.dark,
      opacity: '0.7',
    },


  },
};

export default MuiSelect;
